/* Deniz Doğal Taş — Uzay Sahnesi
 * Test ekranının arkasında çalışan canlı 3B katman.
 * Three.js gerektirir (tema varlığı olarak ayrıca yüklenir).
 *
 * Katmanlar:
 *   1. Yıldız alanı  — parallax ile fareyi/kaydırmayı takip eder
 *   2. Nebula bulutu — yavaş dönen renkli sis
 *   3. Kristal küme  — testin rengine göre renk değiştirir
 *   4. Enerji parçacıkları — soru geçişlerinde patlar
 *
 * Performans: cihaz zayıfsa veya kullanıcı hareket azaltma istiyorsa
 * sahne kurulmaz, CSS gradyanı devreye girer.
 */
(function () {
  "use strict";

  var S = {
    sahne: null, kamera: null, ciziciler: null, kok: null,
    yildizlar: null, kristaller: [], nebula: null, parcaciklar: null,
    fare: { x: 0, y: 0 }, hedef: { x: 0, y: 0 },
    calisiyor: false, kare: 0, renk: new (window.THREE ? window.THREE.Color : Object)(0x0ea5b7),
  };

  function destekVar() {
    if (!window.THREE) return false;
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return false;
    // Eski/zayıf cihazlarda sahneyi hiç kurmuyoruz — pil ve akıcılık için
    if (navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 2) return false;
    try {
      var c = document.createElement("canvas");
      return !!(c.getContext("webgl2") || c.getContext("webgl"));
    } catch (e) { return false; }
  }

  function yildizAlani(THREE) {
    var adet = window.innerWidth < 768 ? 2200 : 5000;
    var geo = new THREE.BufferGeometry();
    var poz = new Float32Array(adet * 3);
    var boy = new Float32Array(adet);
    var renkler = new Float32Array(adet * 3);
    for (var i = 0; i < adet; i++) {
      var r = 60 + Math.random() * 340;
      var t = Math.random() * Math.PI * 2;
      var f = Math.acos(2 * Math.random() - 1);
      poz[i * 3] = r * Math.sin(f) * Math.cos(t);
      poz[i * 3 + 1] = r * Math.sin(f) * Math.sin(t);
      poz[i * 3 + 2] = r * Math.cos(f);
      boy[i] = Math.random() * 2.2 + 0.4;
      // Yıldızların çoğu soğuk beyaz, azı altın — markanın altın vurgusuyla uyum
      var altin = Math.random() > 0.86;
      renkler[i * 3] = altin ? 1 : 0.78 + Math.random() * 0.22;
      renkler[i * 3 + 1] = altin ? 0.84 : 0.82 + Math.random() * 0.18;
      renkler[i * 3 + 2] = altin ? 0.55 : 1;
    }
    geo.setAttribute("position", new THREE.BufferAttribute(poz, 3));
    geo.setAttribute("size", new THREE.BufferAttribute(boy, 1));
    geo.setAttribute("color", new THREE.BufferAttribute(renkler, 3));

    var mat = new THREE.ShaderMaterial({
      uniforms: { uZaman: { value: 0 } },
      vertexShader:
        "attribute float size; attribute vec3 color; varying vec3 vRenk; varying float vParlak;" +
        "uniform float uZaman;" +
        "void main(){ vRenk=color;" +
        "  vParlak = 0.55 + 0.45*sin(uZaman*1.6 + position.x*0.06 + position.y*0.04);" +
        "  vec4 mv = modelViewMatrix * vec4(position,1.0);" +
        "  gl_PointSize = size * (320.0 / -mv.z);" +
        "  gl_Position = projectionMatrix * mv; }",
      fragmentShader:
        "varying vec3 vRenk; varying float vParlak;" +
        "void main(){ vec2 m = gl_PointCoord - vec2(0.5);" +
        "  float d = length(m); if(d>0.5) discard;" +
        "  float a = smoothstep(0.5,0.0,d); a=pow(a,2.2);" +
        "  gl_FragColor = vec4(vRenk, a*vParlak); }",
      transparent: true, depthWrite: false, blending: THREE.AdditiveBlending,
    });
    return new THREE.Points(geo, mat);
  }

  function nebulaBulutu(THREE) {
    var geo = new THREE.PlaneGeometry(900, 900, 1, 1);
    var mat = new THREE.ShaderMaterial({
      uniforms: { uZaman: { value: 0 }, uRenk: { value: new THREE.Color(0x0b4a6f) } },
      vertexShader: "varying vec2 vUv; void main(){ vUv=uv; gl_Position=projectionMatrix*modelViewMatrix*vec4(position,1.0); }",
      fragmentShader:
        "varying vec2 vUv; uniform float uZaman; uniform vec3 uRenk;" +
        // Ucuz değer gürültüsü — mobilde de akıcı kalması için katman sayısı düşük
        "float rast(vec2 p){ return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453); }" +
        "float gurultu(vec2 p){ vec2 i=floor(p), f=fract(p); f=f*f*(3.0-2.0*f);" +
        "  return mix(mix(rast(i),rast(i+vec2(1,0)),f.x), mix(rast(i+vec2(0,1)),rast(i+vec2(1,1)),f.x), f.y); }" +
        "float fbm(vec2 p){ float v=0.0,a=0.5; for(int i=0;i<4;i++){ v+=a*gurultu(p); p*=2.03; a*=0.5; } return v; }" +
        "void main(){ vec2 uv=vUv*3.2;" +
        "  float n = fbm(uv + vec2(uZaman*0.035, uZaman*0.018));" +
        "  n += 0.5*fbm(uv*2.4 - vec2(uZaman*0.022, 0.0));" +
        "  float kenar = smoothstep(0.85,0.15,length(vUv-0.5)*1.6);" +
        "  float yog = smoothstep(0.42,1.05,n) * kenar;" +
        "  gl_FragColor = vec4(uRenk*(0.5+n*0.9), yog*0.42); }",
      transparent: true, depthWrite: false, blending: THREE.AdditiveBlending,
    });
    var m = new THREE.Mesh(geo, mat);
    m.position.z = -320;
    return m;
  }

  function kristal(THREE, yaricap, yukseklik) {
    // Altı yüzlü prizma + sivri uç: doğal kuvars formuna yakın sade geometri.
    // Fiziksel transmission malzemesi ortam haritası olmadan düz renk gibi görünüyor;
    // onun yerine fresnel tabanlı kendi shader'ımızı kullanıyoruz — kenarlar parlar,
    // gövde saydam kalır, arkadaki kozmos görünmeye devam eder.
    var geo = new THREE.ConeGeometry(yaricap, yukseklik, 6);
    var mat = new THREE.ShaderMaterial({
      uniforms: {
        uRenk:  { value: new THREE.Color(0x56d6e6) },
        uKenar: { value: new THREE.Color(0xffd479) },
        uZaman: { value: 0 },
      },
      vertexShader:
        "varying vec3 vNormalD; varying vec3 vGorus; varying float vY;" +
        "void main(){" +
        "  vNormalD = normalize(normalMatrix * normal);" +
        "  vec4 mv = modelViewMatrix * vec4(position,1.0);" +
        "  vGorus = normalize(-mv.xyz);" +
        "  vY = position.y;" +
        "  gl_Position = projectionMatrix * mv; }",
      fragmentShader:
        "varying vec3 vNormalD; varying vec3 vGorus; varying float vY;" +
        "uniform vec3 uRenk; uniform vec3 uKenar; uniform float uZaman;" +
        "void main(){" +
        // Fresnel: yüzeye teğet bakılan yerler parlar, tam karşıdan bakılan yer saydam kalır
        "  float f = pow(1.0 - abs(dot(normalize(vNormalD), normalize(vGorus))), 2.4);" +
        // Gövde boyunca hafif bir iç ışıma dalgası
        "  float dalga = 0.5 + 0.5*sin(vY*0.9 + uZaman*1.3);" +
        "  vec3 renk = mix(uRenk, uKenar, f*0.85);" +
        "  float alfa = 0.10 + f*0.62 + dalga*0.06;" +
        "  gl_FragColor = vec4(renk, alfa); }",
      transparent: true, depthWrite: false, side: THREE.DoubleSide,
      blending: THREE.AdditiveBlending,
    });
    return new THREE.Mesh(geo, mat);
  }

  function kristalKume(THREE) {
    var grup = new THREE.Group();
    var n = window.innerWidth < 768 ? 5 : 9;
    for (var i = 0; i < n; i++) {
      var y = 2.5 + Math.random() * 4.5;
      var k = kristal(THREE, y * 0.26, y);
      var a = (i / n) * Math.PI * 2 + Math.random() * 0.6;
      var r = 22 + Math.random() * 16;
      k.position.set(Math.cos(a) * r, (Math.random() - 0.5) * 22, Math.sin(a) * r - 18);
      k.rotation.set(Math.random() * Math.PI, Math.random() * Math.PI, Math.random() * Math.PI);
      k.userData = {
        hiz: 0.0016 + Math.random() * 0.0032,
        salinim: Math.random() * Math.PI * 2,
        genlik: 0.5 + Math.random() * 1.4,
        temelY: k.position.y,
      };
      grup.add(k);
      S.kristaller.push(k);
    }
    return grup;
  }

  function parcacikSistemi(THREE) {
    var adet = 320;
    var geo = new THREE.BufferGeometry();
    var poz = new Float32Array(adet * 3);
    var hiz = [];
    for (var i = 0; i < adet; i++) {
      poz[i * 3] = poz[i * 3 + 1] = poz[i * 3 + 2] = 0;
      hiz.push(new THREE.Vector3());
    }
    geo.setAttribute("position", new THREE.BufferAttribute(poz, 3));
    var mat = new THREE.PointsMaterial({
      size: 1.5, color: 0xffd479, transparent: true, opacity: 0,
      depthWrite: false, blending: THREE.AdditiveBlending,
    });
    var p = new THREE.Points(geo, mat);
    p.userData = { hiz: hiz, omur: 0 };
    return p;
  }

  /* ---------- döngü ---------- */

  function dongu() {
    if (!S.calisiyor) return;
    requestAnimationFrame(dongu);
    S.kare++;
    var z = S.kare * 0.016;

    // Fare hedefe yumuşak yaklaşır — ani sıçrama olmaz
    S.fare.x += (S.hedef.x - S.fare.x) * 0.045;
    S.fare.y += (S.hedef.y - S.fare.y) * 0.045;

    if (S.yildizlar) {
      S.yildizlar.rotation.y += 0.00028;
      S.yildizlar.rotation.x = S.fare.y * 0.09;
      S.yildizlar.material.uniforms.uZaman.value = z;
    }
    if (S.nebula) {
      S.nebula.material.uniforms.uZaman.value = z;
      S.nebula.material.uniforms.uRenk.value.lerp(S.renk, 0.02);
      S.nebula.rotation.z += 0.00012;
    }
    for (var i = 0; i < S.kristaller.length; i++) {
      var k = S.kristaller[i], d = k.userData;
      k.rotation.y += d.hiz;
      k.rotation.x += d.hiz * 0.45;
      k.position.y = d.temelY + Math.sin(z * 0.7 + d.salinim) * d.genlik;
      if (k.material.uniforms) {
        k.material.uniforms.uZaman.value = z + d.salinim;
        k.material.uniforms.uRenk.value.lerp(S.renk, 0.015);
      }
    }
    if (S.parcaciklar && S.parcaciklar.userData.omur > 0) {
      var u = S.parcaciklar.userData;
      u.omur -= 0.016;
      var p = S.parcaciklar.geometry.attributes.position;
      for (var j = 0; j < u.hiz.length; j++) {
        p.array[j * 3] += u.hiz[j].x;
        p.array[j * 3 + 1] += u.hiz[j].y;
        p.array[j * 3 + 2] += u.hiz[j].z;
        u.hiz[j].multiplyScalar(0.965);
      }
      p.needsUpdate = true;
      S.parcaciklar.material.opacity = Math.max(0, u.omur / 1.6) * 0.85;
    }

    S.kamera.position.x += (S.fare.x * 9 - S.kamera.position.x) * 0.035;
    S.kamera.position.y += (-S.fare.y * 6 - S.kamera.position.y) * 0.035;
    S.kamera.lookAt(0, 0, -18);

    S.cizici.render(S.sahne, S.kamera);
  }

  /* ---------- dış arayüz ---------- */

  function baslat(kok) {
    if (S.calisiyor || !destekVar()) {
      if (kok) kok.classList.add("dz-sahne-yok");
      return false;
    }
    var THREE = window.THREE;
    S.kok = kok;

    var tuval = document.createElement("canvas");
    tuval.className = "dz-uzay-tuval";
    kok.insertBefore(tuval, kok.firstChild);

    S.cizici = new THREE.WebGLRenderer({ canvas: tuval, antialias: true, alpha: true, powerPreference: "high-performance" });
    S.cizici.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    S.cizici.setSize(kok.clientWidth, kok.clientHeight);

    S.sahne = new THREE.Scene();
    S.kamera = new THREE.PerspectiveCamera(58, kok.clientWidth / kok.clientHeight, 0.1, 1200);
    S.kamera.position.set(0, 0, 46);

    S.renk = new THREE.Color(0x0ea5b7);
    S.yildizlar = yildizAlani(THREE); S.sahne.add(S.yildizlar);
    S.nebula = nebulaBulutu(THREE); S.sahne.add(S.nebula);
    S.sahne.add(kristalKume(THREE));
    S.parcaciklar = parcacikSistemi(THREE); S.sahne.add(S.parcaciklar);

    S.sahne.add(new THREE.AmbientLight(0x0a3550, 2.2));
    var l1 = new THREE.DirectionalLight(0x56d6e6, 3.2); l1.position.set(12, 14, 22); S.sahne.add(l1);
    var l2 = new THREE.DirectionalLight(0xffd479, 2.0); l2.position.set(-16, -8, 14); S.sahne.add(l2);

    window.addEventListener("pointermove", function (e) {
      S.hedef.x = (e.clientX / window.innerWidth) * 2 - 1;
      S.hedef.y = (e.clientY / window.innerHeight) * 2 - 1;
    }, { passive: true });

    window.addEventListener("resize", function () {
      if (!S.kok) return;
      S.kamera.aspect = S.kok.clientWidth / S.kok.clientHeight;
      S.kamera.updateProjectionMatrix();
      S.cizici.setSize(S.kok.clientWidth, S.kok.clientHeight);
    }, { passive: true });

    // Sekme arkaplandayken döngüyü durdur — gereksiz pil tüketimi olmasın
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) { S.calisiyor = false; }
      else if (!S.calisiyor) { S.calisiyor = true; dongu(); }
    });

    S.calisiyor = true;
    dongu();
    kok.classList.add("dz-sahne-acik");
    return true;
  }

  // Testin temasına göre sahnenin rengini kaydırır
  function renkAyarla(hex) {
    if (!window.THREE) return;
    S.renk = new window.THREE.Color(hex);
  }

  // Soru geçişlerinde ekranın ortasından parçacık patlaması
  function patlat() {
    if (!S.parcaciklar || !window.THREE) return;
    var u = S.parcaciklar.userData;
    var p = S.parcaciklar.geometry.attributes.position;
    for (var i = 0; i < u.hiz.length; i++) {
      p.array[i * 3] = p.array[i * 3 + 1] = 0; p.array[i * 3 + 2] = 10;
      u.hiz[i].set((Math.random() - 0.5) * 1.5, (Math.random() - 0.5) * 1.5, (Math.random() - 0.5) * 0.9);
    }
    p.needsUpdate = true;
    u.omur = 1.6;
    S.parcaciklar.material.opacity = 0.85;
  }

  window.DenizUzay = { baslat: baslat, renkAyarla: renkAyarla, patlat: patlat, destekVar: destekVar };
})();
